import type { DisplayEditorial, QueryEditorial } from "~/@types/editorial"

export default (editorial: QueryEditorial): DisplayEditorial => {
  if (!editorial) {
    return {} as DisplayEditorial
  }

  return {
    ...editorial,
    teaser: editorial.teaser?.asset?._ref,
    permalink: `/content/${editorial.section.slug?.current}/${editorial.slug.current}`,
  }
}
